<template>
  <!-- FAQs -->
  <b-col class="mb-4" cols="12" md="6">
    <b-container class>
      <!--
      <b-row>
        <b-col cols="12" sm="4" md="6" lg="4" class="p-2 text-center">
          <FAQCard
            :activeSection="activeSection"
            categoryName="Orders"
            icon="tags"
            @open-faq-section="openPopup"
          />
        </b-col>
        <b-col cols="6" sm="4" md="6" lg="4" class="p-2 text-center">
          <FAQCard
            :activeSection="activeSection"
            categoryName="Payments"
            icon="credit-card"
            @open-faq-section="openPopup"
          />
        </b-col>
        <b-col cols="6" sm="4" md="6" lg="4" class="p-2 text-center">
          <FAQCard
            :activeSection="activeSection"
            categoryName="Shipping"
            icon="dolly"
            @open-faq-section="openPopup"
          />
        </b-col>
      </b-row>
      -->
      <b-row class="mt-3 px-2">
        <!-- Answers Template -->
        <b-col
          class="mt-2 mb-2 p-3 answers-section"
          cols="12"
          v-for="(cat,i) in data"
          :key="i"
          v-show="activeSection == i"
        >
          <ul v-for="(question,i) in cat" :key="i">
            <li>
              <h5>{{question[0]}}</h5>
              <h6>{{question[1]}}</h6>
              <hr />
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
//import FAQCard from "./FAQCard.vue";

export default {
  name: "FAQSection",
  components: {
    //   FAQCard,
  },
  methods: {
    openPopup(x) {
      if (x == this.activeSection) {
        this.activeSection = "";
      } else {
        this.activeSection = x;
      }
    },
  },
  data() {
    return {
      activeSection: "Orders",
      data: {
        Orders: [
          ["Do you really stock all of these items?", "Yes. The Christmas items mostly reach us by the end of September. Only some of the New Year items may be delayed until around the middle of November."],
          ["I've placed an inquiry with you. What now?", "Just sit back and we will get in touch with you within a day or two with the next steps."],
          ["I'm interested in a large-scale festive project for a hotel, mall, restaurant, or villa. Can you lend a hand?", "Absolutely; this is our speciality. Get in touch with us through one of the channels on the right and our team will get back to you."],
        ],
        Payments: [
          ["Payments question C1?", "Payments answer C1"],
          ["Payments question B1?", "Payments answer B1"],
          ["Payments question A1?", "Payments answer A1"],
        ],
        Shipping: [
          ["Shipping question A?", "Shipping answer A"],
          ["Shipping question B?", "Shipping answer B"],
          ["Shipping question C?", "Shipping answer C"],
        ],
      },
    };
  },
};
</script>

<style scoped>
ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
li {
  list-style: none;
}

.answers-section {
  border: solid 1px rgba(244, 244, 244, 1);
  border-radius: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.04);
  background: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
